import { Box, Typography, Select, MenuItem } from "@mui/material"
import { useMetrics } from "../../../shared/context/metricsContext"
import { useTheme } from "@mui/material/styles"
import { useEffect, useState } from "react"
import { Bar } from 'react-chartjs-2';
import Chart from 'chart.js/auto';
import ChartDataLabels from 'chartjs-plugin-datalabels';

Chart.register(ChartDataLabels);

export const OtByLocationState = () => {
    const theme = useTheme();
    const { otsByAssetLocationAndStatus, loadingOtsByAssetLocationAndStatus, getOtsByAssetLocationAndStatus, currentLocation } = useMetrics();

    useEffect(() => {
        getOtsByAssetLocationAndStatus();
    }, []);


    const MONTHS = [
        { full: 'enero', short: 'Ene', value: 1 },
        { full: 'febrero', short: 'Feb', value: 2 },
        { full: 'marzo', short: 'Mar', value: 3 },
        { full: 'abril', short: 'Abr', value: 4 },
        { full: 'mayo', short: 'May', value: 5 },
        { full: 'junio', short: 'Jun', value: 6 },
        { full: 'julio', short: 'Jul', value: 7 },
        { full: 'agosto', short: 'Ago', value: 8 },
        { full: 'septiembre', short: 'Sep', value: 9 },
        { full: 'octubre', short: 'Oct', value: 10 },
        { full: 'noviembre', short: 'Nov', value: 11 },
        { full: 'diciembre', short: 'Dic', value: 12 }
    ];
    const [selectMonth, setSelectMonth] = useState(new Date().getMonth() + 1);

    useEffect(() => {
        getOtsByAssetLocationAndStatus({ month: selectMonth });
    }, [selectMonth]);


    const estados = [
        { key: 'in_process', name: 'En Proceso', color: '#3498db' },
        { key: 'review', name: 'En Revisión', color: '#f39c12' },
        { key: 'completed', name: 'Completadas', color: '#17a589' },
        { key: 'cancel', name: 'Canceladas', color: '#566573' }
    ];

    const labels = estados.map(e => e.name);
    const dataValues = estados.map(e => {
        if (!otsByAssetLocationAndStatus || !currentLocation) return 0;
        return otsByAssetLocationAndStatus[currentLocation?.name]?.[e.key] ?? 0;
    });
    const backgroundColors = estados.map(e => e.color);

    const data = {
        labels,
        datasets: [
            {
                label: 'OTs',
                data: dataValues,
                backgroundColor: backgroundColors,
                categoryPercentage: 0.6,
                barPercentage: 0.7,
            }
        ]
    };

    const options = {
        responsive: true,
        plugins: {
            legend: { display: false },
            title: { display: false },
            datalabels: {
                color: '#fff',
                anchor: 'center',
                align: 'center',
                formatter: function (value) {
                    return value;
                },
                font: {
                    weight: 'bold',
                    size: 16
                }
            }
        },
        scales: {
            y: {
                beginAtZero: true,
                ticks: {
                    color: theme.palette.text.primary
                },
                grid: {
                    color: theme.palette.divider
                }
            },
            x: {
                ticks: {
                    color: theme.palette.text.primary
                },
                grid: {
                    color: theme.palette.divider
                }
            }
        }
    };

    return (
        <Box sx={{
            width: '100%',
            backgroundColor: theme.palette.background.paper,
            padding: theme.spacing(2),
            boxShadow: theme.palette.shadow.default,
            borderRadius: theme.spacing(1),
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center'
        }}>
            <Typography variant="body1" sx={{
                fontWeight: 'bold',
                fontSize: { xs: '0.9rem', sm: '1rem' },
                color: theme.palette.text.primary,
                mb: 2
            }}>Cantidad de OTs por estado</Typography>
            <Bar data={data} options={options} />

            <Box sx={{ display: 'flex', justifyContent: 'end', alignItems: 'center', gap: 1, width: '100%', mt: 2 }}>
                <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
                    Seleccione el mes:
                </Typography>
                <Select
                    value={selectMonth}
                    onChange={(e) => setSelectMonth(e.target.value)}
                    size="small"
                >
                    {MONTHS.map(month => (
                        <MenuItem key={month.value} value={month.value}>{month.full}</MenuItem>
                    ))}
                </Select>
            </Box>
        </Box>
    )
}